<script>
import UsersApi from "@/services/users-api";

export default {
    mounted() {
        this.role=sessionStorage.getItem("userr");
        if(this.role == 0){
            this.getTrader()
        }
    },

    data() {
      return {
        role:null,
        selectedTrader:null,
        showModal:false,
    }
      },

    methods :{
      getTrader(){
          UsersApi.getTrader(null).then(
              (result)=>{
                  if(result && result.id){
                      this.selectedTrader=result
                  }else{
                      this.selectedTrader=null
                  }

              }
          )
      }
    }
}
</script>
<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row pl-2 pr-2">
        <div :class="selectedTrader && selectedTrader.name ? 'col-sm-4' : 'col-sm-6'">
          <div >
            <a href="http://www.amiral.io" class="text-muted" target="_blank">{{ new Date().getFullYear() }} v6.2.14 © Amiral</a>
          </div>
        </div>
        <div class="col-sm-4 text-sm-center" v-if="selectedTrader && selectedTrader.name">
          {{$t('footer.trader')}} <u style="cursor:pointer" class="text-primary font-weight-bold ml-1" @click="showModal=true"> {{this.selectedTrader.name}}</u>
        </div>
        <div :class="selectedTrader && selectedTrader.name ? 'col-sm-4' : 'col-sm-6'">
          <div class="float-right">
            <div class="text-sm-right d-none d-sm-block">Powered by <a href="http://www.amiral.io" class="text-primary" target="_blank">Amiral</a></div>
          </div>
        </div>
      </div>
    </div>

  <b-modal v-if="selectedTrader"
    v-model="showModal"
        title=""
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        hide-footer
        hide-header
        size="md">

            <div class="row mb-1 mt-0">
              <span class=" font-size-16 font-weight-bold text-primary"><i class="fas fa-user-tie font-size-16 mr-2 "/>{{selectedTrader.name == null ? "-" : selectedTrader.name}}</span>
            </div>
            <div class="row mb-3">
              <span class="font-size-14 font-italic">{{selectedTrader.jobTitle == null ? "" : selectedTrader.jobTitle   }}</span>
            </div>

            <div class="row mb-1">
              <span class="font-size-14 text-grey"><i class="fas fa-phone font-size-16 mr-2"/> </span>
              <span class="font-size-14 font-italic">{{selectedTrader.phone == null ? "-" : selectedTrader.phone}}</span>
            </div>

            <div class="row mb-0">
              <span class="font-size-14 text-grey"><i class="fas fa-envelope font-size-16 mr-2"/> </span>
              <span class="font-size-14 font-italic">{{selectedTrader.userName== null ? "-" :selectedTrader.userName }}</span>
            </div>

    </b-modal>

  </footer>
  <!-- end footer -->
</template>
